export default {
  // Visual component - no static translatable strings
}
